import React from 'react';
import '../template-file-css/document-file-template.css';


export const BFCS_WeeklyCaseSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='BFCS_WeeklyCaseSummary' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Therapist's Name:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtTherapist" name="txtTherapist" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Supervision Date:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Case open date:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Anticipated close date:</span>
                        </td> 
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtSupervision" name="txtSupervision" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtCaseOpen" name="txtCaseOpen" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtAnticipated21" name="txtAnticipated21" className='add-only' />
                        </td> 
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Number of face to face contact in the past 7 days:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Total face to face time in hours for the past 7 days:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtFaceFace" name="txtFaceFace" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtFaceFace1" name="txtFaceFace1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Number of phone contacts in the past 7 days:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Number of cancelled/missed sessions:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPhoneContact" name="txtPhoneContact" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCancelled" name="txtCancelled" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Engagement rating:</span>
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbEngagement_1" name="rbEngagement" className='add-only' value="1" /> 0 - not at all
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbEngagement_2" name="rbEngagement" className='add-only' value="2" /> 1 - minimal engagement
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbEngagement_3" name="rbEngagement" className='add-only' value="3" /> 2- somewhat engaged with slight follow-through
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbEngagement_4" name="rbEngagement" className='add-only' value="4" /> 3- Partially engaged with moderate follow-through and moderate participation in interventions
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbEngagement_5" name="rbEngagement" className='add-only' value="5" /> 4- Engaged - bought in to model and actively participate in interventions
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbEngagement_6" name="rbEngagement" className='add-only' value="6" /> 5- Fully engaged in treatment
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>1.Referral Behaviors</span>
                    <span className='small'>(list all referral behaviors)</span>
                    <textarea id="txtReferral" name="txtReferral" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2.Overarching MST Goals:</span>
                    <span className='small'>(Rating Scale of Completion 0-5)</span>
                </p>
                <p className='w-750'>
                    <b>I.</b>
                    <br/>
                     <textarea id="txtOverarching" name="txtOverarching" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>II.</b>
                    <br/>
                     <textarea id="txtOverarching1" name="txtOverarching1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>III.</b>
                    <br/>
                    <textarea id="txtOverarching2" name="txtOverarching2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>IV.</b>
                    <br/>
                    <textarea id="txtOverarching3" name="txtOverarching3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3.Previous Intermediary Goals and interventions:</span>
                </p>
                <p className='w-750'>
                    <b>IG1.</b> &nbsp; &nbsp;
                    <input type="radio" id="rbIntermediary1_1" name="rbIntermediary1" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbIntermediary1_2" name="rbIntermediary1" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbIntermediary1_3" name="rbIntermediary1" className='add-only' value="3" /> Not Met
                    
                    <textarea id="txtIntermediary" name="txtIntermediary" className='add-only'></textarea> 
                </p>
                <p className='w-750'>
                    <b>IG2.</b> &nbsp; &nbsp;
                    <input type="radio" id="rbIntermediary2_1" name="rbIntermediary2" className='add-only' value="1" />Met &nbsp;
                    <input type="radio" id="rbIntermediary2_2" name="rbIntermediary2" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbIntermediary2_3" name="rbIntermediary2" className='add-only' value="3" /> Not Met
                    
                    <textarea id="txtIntermediary2" name="txtIntermediary2" className='add-only'></textarea> 
                </p>
                <p className='w-750'>
                    <b>IG3.</b> &nbsp; &nbsp;
                    <input type="radio" id="rbIntermediary3_1" name="rbIntermediary3" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbIntermediary3_2" name="rbIntermediary3" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbIntermediary3_3" name="rbIntermediary3" className='add-only' value="3" /> Not Met
                    
                    <textarea id="txtIntermediary3" name="txtIntermediary3" className='add-only'></textarea> 
                </p>
                <p className='w-750'>
                    <b>IG4.</b> &nbsp; &nbsp;
                    <input type="radio" id="rbIntermediary4_1" name="rbIntermediary4" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbIntermediary4_2" name="rbIntermediary4" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbIntermediary4_3" name="rbIntermediary4" className='add-only' value="3" /> Not Met
                    
                    <textarea id="txtIntermediary4" name="txtIntermediary4" className='add-only'></textarea> 
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4.Previous Supervisor Recommendations:</span>
                    <textarea id="txtSupervisor" name="txtSupervisor" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>5.Previous Consultation Recommendations:</span>
                    <textarea id="txtConsultation" name="txtConsultation" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>6.Barriers to Previous Intermediary Goals:</span>
                </p>
                <p className='w-750'>
                    <b>IG 1. </b> &nbsp; &nbsp;
                    <input type="radio" id="rbBarriers_1" name="rbBarriers" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbBarriers_2" name="rbBarriers" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbBarriers_3" name="rbBarriers" className='add-only' value="3" /> Not Met
                    <textarea id="txtBarriers" name="txtBarriers" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>IG 2. </b> &nbsp; &nbsp;
                    <input type="radio" id="rbBarriers2_1" name="rbBarriers2" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbBarriers2_2" name="rbBarriers2" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbBarriers2_3" name="rbBarriers2" className='add-only' value="3" /> Not Met
                    <textarea id="txtBarriers1" name="txtBarriers1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>IG 3. </b> &nbsp; &nbsp;
                    <input type="radio" id="rbBarriers3_1" name="rbBarriers3" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbBarriers3_2" name="rbBarriers3" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbBarriers3_3" name="rbBarriers3" className='add-only' value="3" /> Not Met
                    <textarea id="txtBarriers2" name="txtBarriers2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>IG 4. </b> &nbsp; &nbsp;
                    <input type="radio" id="rbBarriers4_1" name="rbBarriers4" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbBarriers4_2" name="rbBarriers4" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbBarriers4_3" name="rbBarriers4" className='add-only' value="3" /> Not Met
                    <textarea id="txtBarriers3" name="txtBarriers3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>7.Advances in treatment:</span>
                </p>
                <p className='w-750'>
                    <b>IG 1. </b> &nbsp; &nbsp;
                    <input type="radio" id="rbAdvances1_1" name="rbAdvances1" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbAdvances1_2" name="rbAdvances1" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbAdvances1_3" name="rbAdvances1" className='add-only' value="3" /> Not Met
                    <textarea id="txtAdvances" name="txtAdvances" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>IG 2. </b> &nbsp; &nbsp;
                    <input type="radio" id="rbAdvances2_1" name="rbAdvances2" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbAdvances2_2" name="rbAdvances2" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbAdvances2_3" name="rbAdvances2" className='add-only' value="3" /> Not Met
                    <textarea id="txtAdvances2" name="txtAdvances2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>IG 3. </b> &nbsp; &nbsp;
                    <input type="radio" id="rbAdvances3_1" name="rbAdvances3" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbAdvances3_2" name="rbAdvances3" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbAdvances3_3" name="rbAdvances3" className='add-only' value="3" /> Not Met
                    <textarea id="txtAdvances3" name="txtAdvances3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>IG 4. </b> &nbsp; &nbsp;
                    <input type="radio" id="rbAdvances4_1" name="rbAdvances4" className='add-only' value="1" /> Met &nbsp;
                    <input type="radio" id="rbAdvances4_2" name="rbAdvances4" className='add-only' value="2" /> Part Met &nbsp;
                    <input type="radio" id="rbAdvances4_3" name="rbAdvances4" className='add-only' value="3" /> Not Met
                    <textarea id="txtAdvances4" name="txtAdvances4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>8.How has your assessment of the “fit” between problems and their systemic context changed or expanded?</span>
                    <textarea id="txtFit" name="txtFit" className='add-only'></textarea>
                    <textarea id="txtFit1" name="txtFit1" className='add-only'></textarea>
                    <textarea id="txtFit2" name="txtFit2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>9. New Intermediary Goals and Interventions for Next Week:</strong>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 1.</span>
                </p>
                <p className='w-750'>
                    <b>A</b>
                    <br/>
                    <textarea id="txtInterventions" name="txtInterventions" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>B</b>
                    <br/>
                    <textarea id="txtInterventions1" name="txtInterventions1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>C</b>
                    <br/>
                    <textarea id="txtInterventions2" name="txtInterventions2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>D</b>
                    <br/>
                    <textarea id="txtInterventions3" name="txtInterventions3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 2.</span>
                </p>
                <p className='w-750'>
                    <b>A</b>
                    <br/>
                    <textarea id="txtInterventions4" name="txtInterventions4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>B</b>
                    <br/>
                    <textarea id="txtInterventions5" name="txtInterventions5" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>C</b>
                    <br/>
                    <textarea id="txtInterventions6" name="txtInterventions6" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>D</b>
                    <br/>
                    <textarea id="txtInterventions7" name="txtInterventions7" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 3.</span>
                </p>
                <p className='w-750'>
                    <b>A</b>
                    <br/>
                    <textarea id="txtInterventions8" name="txtInterventions8" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>B</b>
                    <br/>
                    <textarea id="txtInterventions9" name="txtInterventions9" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>C</b>
                    <br/>
                    <textarea id="txtInterventions10" name="txtInterventions10" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>D</b>
                    <br/>
                    <textarea id="txtInterventions11" name="txtInterventions11" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>10. Anticipated Barrier(s) to New Intermediary Goals:</span>
                    <textarea id="txtAnticipated" name="txtAnticipated" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>11. Question(s) for Supervision for Supervision/Consultation:</span>
                    <textarea id="txtQuestion" name="txtQuestion" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>12. Supervision Feedback: (Completed by Supervision)</span>
                    <textarea id="txtSupervision21" name="txtSupervision21" className='add-only'></textarea>
                </p>





            </div>
        </form>

    )
}











